import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchDowntimeCategories({ downtimeCategoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `DowntimeCategory/getSearched`,
      params: downtimeCategoryParams,
    });
    const allDowntimeCategory = data;
    yield put(Actions.setAll({ allDowntimeCategory }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateDowntimeCategory({ downtimeCategoryData, actionName, downtimeCategoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `downtimecategory`,
      data: downtimeCategoryData,
    });
    yield put(Actions.fetchDowntimeCategories({ downtimeCategoryParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.DOWNTIME_CATEGORY_CREATED
        : CONSTANT_VARIABLES.DOWNTIME_CATEGORY_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteDowntimeCategory({ id, downtimeCategoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `downtimecategory/${id}`,
    });
    yield put(Actions.fetchDowntimeCategories({ downtimeCategoryParams }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_CATEGORY_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_DOWNTIME_CATEGORIES, fetchDowntimeCategories),
    takeLatest(ActionTypes.ADD_OR_UPDATE_DOWNTIME_CATEGORY, addorUpdateDowntimeCategory),
    takeLatest(ActionTypes.DELETE_DOWNTIME_CATEGORY, deleteDowntimeCategory),
  ]);
}
